// D-0097 (Rafael 24/10): tela de Detalhe do adiantamento. "Precisa ver os itens que estão sendo
// solicitados para que possa criar o recibo para cliente." Helpers puros da tela.

export const rotaDetalheAdiantamento = (id) => '/financeiroAdiantamentoDetalhe/' + id;

// É adiantamento? Conta a receber (tipo 2) com título "Adiantamento…" — a mesma leitura das listas.
export function ehAdiantamento(parcela) {
    if (!parcela) return false;
    const descricao = String((parcela.titulo && parcela.titulo.descricao) || parcela.descricao || '');
    return String(parcela.tipo) === '2' && descricao.indexOf('Adiantamento') === 0;
}

// Situação para o KPI: { texto, tom (is-ok | is-warn | is-danger), sub }. No adiantamento,
// `dataAprovacaoDiretor` NÃO é aprovação de diretor: é gravado ao anexar o recibo ou no Informar
// Crédito, e o item vai para Custo Previsto › Aprovados pelo Financeiro. Só `liberado_financeiro_at`
// quer dizer que ele está em Contas Pendentes.
export function situacaoAdiantamento(p, formatarData = (d) => d) {
    if (!p) return { texto: '—', tom: '', sub: '' };
    if (p.removido_em) return { texto: 'Excluído', tom: 'is-danger', sub: 'Pedido removido' };
    if (p.dataReprovacaoDiretor) return { texto: 'Reprovado', tom: 'is-danger', sub: p.motivoReprovacaoDiretor || 'Reprovado pelo diretor' };
    if (String(p.situacao) === '2') return { texto: 'Pago', tom: 'is-ok', sub: p.pagamento ? 'Baixa em ' + formatarData(p.pagamento) : 'Baixa feita' };
    if (p.status_pagamento === 'creditado') return { texto: 'Creditado', tom: 'is-ok', sub: 'O cliente pagou' };
    if (p.status_pagamento === 'nao_creditado') return { texto: 'Não creditado', tom: 'is-warn', sub: 'O valor não caiu — em renegociação' };
    const onde = p.liberado_financeiro_at ? 'Em Contas Pendentes'
        : (p.dataAprovacaoDiretor ? 'Em Aprovados pelo Financeiro' : 'Aguardando recibo ou crédito');
    return { texto: 'Aguardando crédito', tom: 'is-warn', sub: onde };
}

// Quantos grupos e itens: "41 itens em 12 grupos".
export function resumoItens(itens = []) {
    const lista = Array.isArray(itens) ? itens : [];
    const grupos = new Set(lista.map((i) => String(i.grupo_id || '')));
    const n = lista.length;
    if (n === 0) return 'Sem itens do orçamento';
    return n + (n === 1 ? ' item' : ' itens') + ' em ' + grupos.size + (grupos.size === 1 ? ' grupo' : ' grupos');
}

// O clique foi num controle da linha (botão, link, campo)? Então não é "abrir o detalhe".
export function cliqueEmControle(alvo) {
    return !!(alvo && typeof alvo.closest === 'function' && alvo.closest('button, a, input, select, textarea, label, form'));
}

// Métrica 12/10 (item 12): quantas vezes o adiantamento voltou ao Eventos (reprovado / não creditado).
export const VOLTA_ADIANTAMENTO = ['adiantamento_reprovado', 'adiantamento_nao_creditado'];
export function contarVoltas(historico = []) {
    return (Array.isArray(historico) ? historico : []).filter((h) => h && VOLTA_ADIANTAMENTO.includes(h.evento)).length;
}

// D-0118 (Rafael 27/10): o que o Financeiro precisa para emitir o recibo — datas do evento, para
// quem vai o recibo (responsável do cliente cadastrado no evento) e as P.O. do evento. A API manda
// em `parcela.dados_recibo` (lista de adiantamentos e Detalhe).
function dataBr(valor) {
    if (!valor) return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor));
    return m ? m[3] + '/' + m[2] + '/' + m[1] : String(valor);
}

// "12/11/2026 a 14/11/2026" (ou só o início); "—" sem data.
export function periodoEvento(dados) {
    if (!dados || !dados.data) return '—';
    const ini = dataBr(dados.data);
    const fim = dados.dataFim ? dataBr(dados.dataFim) : '';
    return fim && fim !== ini ? ini + ' a ' + fim : ini;
}

// { nome, email, cargo } do responsável do cliente, ou null quando o evento não tem cadastro.
export function destinatarioRecibo(dados) {
    return (dados && dados.destinatario && dados.destinatario.nome) ? dados.destinatario : null;
}

// { tipo: 'lista' | 'nao_aplica' | 'nenhuma', pos: [...] } — a tela decide o texto e os botões.
export function posDoEvento(dados) {
    const pos = (dados && Array.isArray(dados.pos)) ? dados.pos : [];
    if (pos.length > 0) return { tipo: 'lista', pos };
    if (dados && dados.po_nao_aplicavel) return { tipo: 'nao_aplica', pos: [] };
    return { tipo: 'nenhuma', pos: [] };
}
